import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { replaceCommaIntoWhiteSpace } from '../CommonUtilities/commonUtilities';

const NumberFormatCustom = (props) => {
  const { inputRef, name, onChange, onBlur, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: name,
            value: values.value,
          },
        });
      }}
      onBlur={(e) => {
        onBlur({
          target: {
            name: name,
            value: replaceCommaIntoWhiteSpace(e.target?.value),
          },
        });
      }}
      decimalScale={2}
      fixedDecimalScale
      // isAllowed={(values) => {
      //   const { formattedValue, floatValue } = values;
      //   return formattedValue === '' || floatValue <= 999999999.99;
      // }}
      thousandSeparator
      isNumericString
      allowNegative
    />
  );
};
export default NumberFormatCustom;
NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
};
